import React, { useEffect, useState } from "react";
import { useRoles } from "../../hooks";
import { Typography } from "antd";
const { Text } = Typography;

const UserRoles = (props) => {
  const { record } = props;
  const [roleName, setRoleName] = useState();
  const allRoles = useRoles();
  useEffect(() => {
    if (
      record.roles &&
      record.roles.length > 0 &&
      allRoles &&
      allRoles.length > 0
    ) {
      const userRole = allRoles.filter(
        (role) => role.id === record.roles[0].role_id
      )[0];
      setRoleName(userRole ? userRole.name : "");
    }
  }, [allRoles, record.roles]);

  return <Text>{roleName}</Text>;
};

export default UserRoles;
